//console.log('ConditionsReports.index.js loaded');
//-[Violation]
var tw = tw || {};
tw.ConditionsReports = (function () {
	var _log = false, 
		isTouch = $('html').hasClass('touch'),
		initLoadResize = true,
		activeRoute = null,
		reportType = $("[data-reporttype]").data("reporttype"),
		reportSubcode = $("[data-reportsubcode]").data("reportsubcode"),
		baseTitle = $("[data-metatitlebase]").data("metatitlebase"),
		ogImages = [],
		host = window.location.host,
		protocol = (window.location.protocol == 'https') ? 'https' : 'http',
		basePath = decodeURIComponent($("[data-basepath]").data("basepath")),
		baseUrl = protocol + '://' + host + basePath + '/',
		imgBaseUrl = '',//"http://www.travelwisconsin.com",
		map = null,
		gallery = [],
		baseCategory = '',
		baseAction = '',
		useHref = '',
		urlParams = BingMap.Utilities.getUrlParams(),
		currentReportPane,
		isSnowReport = false;


	if(reportType == "snowmobile" || reportType == 'crosscountry' || reportType == 'downhill') {
		ogImages['downhill'] = $("[data-ogimage-downhill]").data("ogimage-downhill");
		ogImages['crosscountry'] = $("[data-ogimage-crosscountry]").data("ogimage-crosscountry");
		ogImages['snowmobile'] = $("[data-ogimage-snowmobile]").data("ogimage-snowmobile");
		isSnowReport = true;
	}

	if (_log) console.log('urlParams:', urlParams);
	if (_log) console.log('basePath:', basePath);
	

	var $subpanes = $('.js-subpane'),
		$pane = $('.js-pane'),
		$reportButtons = $('.js-report-button'),
		$subpaneButtons = $('.js-subpane-button'),
		$toolbar = $('.js-toolbar'),
        $toolbarSecondaryButtons = $('.js-toolbar-secondary-button'),
		$extraToolContainer = $('.js-toolbar-extra');

	//templates
	var photoThumbTemplate = $('#photoThumbTemplate').html(),
        photoYearHeaderTemplate = $('#photoYearHeaderTemplate').html(),
		photoDetailTemplate = $('#photoDetailTemplate').html();
		
	var reportTypeEnum = {
		trail: 'trail',
		fallcolor: 'fallcolor',
		snowmobile: 'snowmobile',
		downhill: 'downhill',
		crosscountry: 'crosscountry'
	}
	var reportSubcodeEnum = {
		biking: 'biking',
		hiking: 'hiking'
	}
		

	//report titles for Google Analytics and Page Title
	//DSR request specific GA/Page titles
	//NOTE: PageTitle is different that gaLong on purpose. Keep updated in tandem with /Controllers/ConditionsReports lines ~70-100
	var reportTitles = {
		biking: {
			gaShort: 'Biking',
			gaLong: 'Biking Report',
			pageTitle: 'Wisconsin Biking Trail Report | Travel Wisconsin',
			description: 'The Wisconsin Biking Trail Report is the best place to find open biking locations & current trail conditions throughout the state. Click here for more!'
		},
		hiking: {
			gaShort: 'Hiking',
			gaLong: 'Hiking Report',
			pageTitle: 'Wisconsin Hiking Trail Report | Travel Wisconsin',
			description: 'The Wisconsin Hiking Trail Report is the best place to find open hiking locations & current trail conditions throughout the state. Explore the report!'
		},
		crosscountry: {
			gaShort: 'Cross Country',
			gaLong: 'Cross Country Skiing',
			pageTitle: 'Cross Country Ski Report | Wisconsin Snow Report',
			description: 'Find the latest info on cross country ski trail conditions in the Wisconsin Snow Report. Be prepared with a local weather forecast & list of nearby activities!'
		},
		downhill: {
			gaShort: 'Downhill',
			gaLong: 'Downhill and Snowboarding',
			pageTitle: 'Downhill Ski Report | Wisconsin Snow Report',
			description: 'Get the downhill ski conditions in the Wisconsin Snow Report. Prepare for your downhill ski adventure with info on snow conditions, weather & nearby activities!'

		},
		snowmobile: {
			gaShort: 'Snowmobile',
			gaLong: 'Snowmobile',
			pageTitle: 'Snowmobile Trail Conditions | Wisconsin Snow Report',
			description: 'Get snowmobile trail conditions in the Wisconsin Snow Report. Prepare for your snowmobiling adventures with info on snow conditions, weather & nearby activities!'

		},
		fallcolor: {
			gaShort: 'Fall Color',
			gaLong: 'Fall Color',
			pageTitle: 'Fall Color Map | Fall Color Report',
			description: 'Find the most comprehensive resource on fall colors available in Wisconsin. Get the best locations for viewing fall colors throughout autumn.'
		}

	};

	var checkReportType = function () {
		if (_log) console.log('tw.ConditionsReports.checkReportType().reportType:', reportType);
		if (_log) console.log('tw.ConditionsReports.checkReportType().urlParams:', urlParams);

		var urlParamsString = '';
		if(urlParams != undefined) {
			const params = new URLSearchParams(urlParams);
			urlParamsString = '?' + params.toString();
		}
		if (_log) console.log('tw.ConditionsReports.checkReportType().urlParamsString:', urlParamsString);

		switch(reportType) {
			case reportTypeEnum.trail:
				baseCategory = "Trail Report";
				switch(reportSubcode.toLowerCase()) {
					case reportSubcodeEnum.biking:
						// baseCategory = 'Biking Report';
						baseAction = 'Biking';
						useHref = '/biking-report' + urlParamsString;
						$('.js-pane-header h2').html('Biking Conditions');
						toggleTrailFilters(reportSubcodeEnum.biking);
						break;
					default:
						// baseCategory = 'Hiking Report';
						baseAction = 'Hiking';
						useHref = '/hiking-report' + urlParamsString;
						$('.js-pane-header h2').html('Hiking Conditions');
						toggleTrailFilters(reportSubcodeEnum.hiking);
				}
				break;
			case reportTypeEnum.fallcolor:
				baseCategory = 'Fall Color Report';
				baseAction = 'Fall Color';
				useHref = basePath + urlParamsString;
				break;
			default:
				baseCategory = 'Snow Conditions Report';
				baseAction = 'Snow Conditions';
				useHref = basePath + '/' + reportType + urlParamsString;
				toggleFilters();
				$('.js-pane-header h2').html(reportTitles[reportType]['gaShort'] + ' Conditions');
		}
		if (_log) console.log('baseCategory:', baseCategory);
		if (_log) console.log('useHref:', useHref);

		var viewedDownhillAlert = $.cookie('viewedDownhillAlert');
		if (_log) console.log('viewedDownhillAlert:', viewedDownhillAlert);

		if(reportType == reportTypeEnum.downhill && viewedDownhillAlert == undefined) {
			//openDowhillModal();
			$.cookie('viewedDownhillAlert', 'true', { expires: 1 });
		}


		var viewedTrailAlert = $.cookie('viewedTrailAlert');
		if (_log) console.log('viewedTrailAlert:', viewedTrailAlert);

		if(reportType == reportTypeEnum.trail && viewedTrailAlert == undefined) {
			/*openTrailModal();*/
			$.cookie('viewedTrailAlert', 'true', { expires: 1 });
		}

		if(reportType == reportTypeEnum.crosscountry || reportType == reportTypeEnum.downhill) {
			$('.js-accordion-amenities').removeClass('hidden');
    
			const $checkboxes = $('.js-accordion-body input[type="checkbox"]');
			const $label = $('.js-accordion-btn span');
		
			function updateLabel() {
				const uniqueCheckedFilters = new Set();

				$checkboxes.filter(':checked').each(function () {
					uniqueCheckedFilters.add($(this).attr('data-filter'));
				});

				const selectedCount = uniqueCheckedFilters.size;
				$label.text(`Amenities${selectedCount > 0 ? ` (${selectedCount})` : ''}`);
			}

			function syncCheckboxes(filter, isChecked) {
				$checkboxes.filter(`[data-filter="${filter}"]`).prop('checked', isChecked);
			}

			$checkboxes.on('change', function () {
				const filter = $(this).attr('data-filter');
				const isChecked = $(this).is(':checked');
		
				syncCheckboxes(filter, isChecked);
		
				updateLabel();
			});
		
			updateLabel();
		} else {
			$('.js-accordion-amenities').addClass('hidden');
		}
		
	}

	var getBaseCategory = function () {
		if (_log) console.log('tw.ConditionsReports.getBaseCategory:', baseCategory);
		return baseCategory;
	}



	var filters = {
		crosscountry: [
			'open',
			'sortCondition',
			'skijoring',
			'snowshoeing',
			'winterFatBiking',
			'equipmentRentals',
			'warmingShelterLodge',
			'snowMaking',
			'lightedTrails'
		],
		downhill: [
			'open',
			'sortCondition',
			'tubing',
			'lodge',
			'lodging',
			'nightSkiing',
			'skiSchool',
			'ticketPrice',
			'ticketPromo',
			'skiSchool',
			'adaptiveProgram',
			'equipmentRentals'
		],
		snowmobile: [
			'open',
			'sortCondition',
			'dnr'
		]	
	}

	var trailFilters = {
		hiking: [
			'open',
			'dnr',
			'ice',
			'sortCondition'
		],
		biking: [
			'open',
			'dnr',
			'sortCondition'
		]
	}	

	/**
	 * toggle filters visibility for SCR
	*/
	var toggleFilters = function () {
		//if (_log) console.log('tw.ConditionsReports.toggleFilters:', reportType);

		$('.js-reports-filter-label.reports__filter').removeClass('d-block').addClass('hidden');
		$('.js-reports-filter-label.reports__filter23').removeClass('d-flex').addClass('hidden');

		filters[reportType].forEach(filter => {
			//console.log('filter:', filter);
			$('.reports__filter[for="filter-' + filter + '"]').removeClass('hidden').addClass('d-block');
			$('.reports__filter23[for="filter-' + filter + '"]').removeClass('hidden').addClass('d-flex');
		});
	}

	/**
	 * toggle filters visibility for Trail
	*/
	var toggleTrailFilters = function (subcode) {
		// Clear existing filters
		$('.js-reports-filter-label.reports__filter').removeClass('d-block').addClass('hidden');
		$('.js-reports-filter-label.reports__filter23').removeClass('d-flex').addClass('hidden');

		// Add new filters based on the reportSubcode
		trailFilters[subcode].forEach(filter => {
			$('.reports__filter[for="filter-' + filter + '"]').removeClass('hidden').addClass('d-block');
			$('.reports__filter23[for="filter-' + filter + '"]').removeClass('hidden').addClass('d-flex');
		});
	}



	var lastOpenId = null;
	var toggleAccordion = function (id = null) {
		var wasOpen = id == null ? false : $('.js-accordion-body[data-body-id="' + id + '"]').hasClass('active');
		// console.log('toggleAccordion.id:', id);
		// console.log('toggleAccordion.wasOpen:', wasOpen);

		$('.js-accordion-body').removeClass('active');
		$('.js-accordion-btn .fas').removeClass('fa-chevron-up').addClass('fa-chevron-down');

		if(id != null && (lastOpenId != id || !wasOpen)) {
			$('.js-accordion-body[data-body-id="' + id + '"]').addClass('active');
			$('.js-accordion-btn[data-btn-id="' + id + '"] .fas').removeClass('fa-chevron-down').addClass('fa-chevron-up');
			lastOpenId = id;
		}
	}
	toggleAccordion(null);

	$('.js-accordion-btn').on('click', function () {
		var btnId = $(this).data('btn-id');
		//console.log('js-accordion-btn.btnId:', btnId);
		toggleAccordion(btnId);
	});

    var filterScrolledTop = true;
	$('.js-sticky-filter').on('click', '.js-accordion-filter-btn', function () {
		if (isLargeLayout() === true) {
			var accordion = $(this).closest('.js-sticky-filter');
			var body = accordion.find('.js-accordion-filter-body');
			body.toggleClass('active');
			$(this).find('.js-filter-chevron').toggleClass('fa-chevron-up fa-chevron-down');
		}
	});		
	$('.js-sticky-filter').on('click', '.js-filter-accordion-btn', function () {
		if (isLargeLayout() === true) {
			var accordion = $(this).closest('.js-sticky-filter');
			var body = accordion.find('.js-filter-accordion-body');
			body.toggleClass('active');
			$(this).find('.js-filter-chevron').toggleClass('fa-chevron-up fa-chevron-down');
		}
	});
	/**
	 * LAZYLOAD    (https://github.com/verlok/lazyload)
	 * Usage Example: 
	 * <img src="" data-src="path/to/image.ext" class="js-lazy" alt="">
	 * After load, if adding more JS-Lazy items to the stage, run this: crLazyLoad.update();
	 */
	var crLazyLoad = new LazyLoad({
		elements_selector: '.js-lazy'
	});

	/**
	 * Initialize Page
	 * */
	var initializePage = function () {
		if (_log) console.group('tw.ConditionsReports.initializePage()');

		checkReportType();

		var useRoute = (reportSubcode) ? reportSubcode.toLowerCase() : reportType;

		if (_log) console.log('isTouch', isTouch);
		if (_log) console.log('baseUrl', baseUrl);
		if (_log) console.log('baseTitle:' + baseTitle);
		if (_log) console.log('reportType:' + reportType);
		if (_log) console.log('reportSubcode:' + reportSubcode);
		if (_log) console.log('useRoute:' + useRoute);


		if (reportSubcode) {
			$("[data-subcode='" + useRoute + "']").addClass('is-active');
		} else {
			$("[data-route='" + useRoute + "']").addClass('is-active');
		}

		activeRoute = useRoute;//reportType;

		BingMap.Map.initializeButtons();
		BingMap.Map.updateReportType(reportType);
		tw.ConditionReportsListings.getAllReportsByRegion();
		
		var txt = activeRoute,
			href = useHref,
			obj = {
				path: href,
				text: txt
			};
		window.history.pushState(obj, txt, href);
		if (_log) console.log('window.history.pushState(' + JSON.stringify(obj) + ', ' + txt + ', ' + href + ')');

		/**
		 * Listener for browser Back button
		 */
		window.addEventListener('popstate', function(e) {
			if (_log) console.log('popstate.e: ', e);
			if (_log) console.log('popstate.e.state: ', e.state);
			if (e.state != null && e.state!= undefined) {
				var route = e.state.text;
				if (_log) console.log('popstate.route: ', route);
				reportType = route;
				clearActive($subpaneButtons);
				closeSubpanes();
				openPane();
				tw.ConditionReportsListings.showReports();
				$('body').removeClass('is-hidden-map');
				tw.ConditionReportsListings.showAllReports();
				clearActive($reportButtons);
				$('.js-report-button[data-route="' + route + '"]').addClass('is-active');
				changeUrl();
			}
			
		});

		//Hold for when they want to bring this back. JK 2025-03-04
		// //if (reportType == reportTypeEnum.fallcolor){
		// if (isSnowReport){
		// 	function setCookie(name, value, days) {
		// 		var expires = "";
		// 		if (days) {
		// 			var date = new Date();
		// 			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		// 			expires = "; expires=" + date.toUTCString();
		// 		}
		// 		document.cookie = name + "=" + (value || "") + expires + "; path=/";
		// 	}

		// 	function getCookie(name) {
		// 		var nameEQ = name + "=";
		// 		var ca = document.cookie.split(';');
		// 		for (var i = 0; i < ca.length; i++) {
		// 			var c = ca[i];
		// 			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		// 			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
		// 		}
		// 		return null;
		// 	}

		// 	function closeModal() {
		// 		const popup = document.querySelector('.js-conditions-popup');
		// 		const overlay = document.querySelector('.js-conditions-popup-overlay');

		// 		popup.classList.add('d-none');
		// 		overlay.classList.add('d-none');
		// 		document.body.classList.remove('modal-open');					
		// 	}

		// 	if (!getCookie('viewedSurveyPopup')) {
		// 		setTimeout(function () {
		// 			const popup = document.querySelector('.js-conditions-popup');
		// 			const overlay = document.querySelector('.js-conditions-popup-overlay');
										
		// 			popup.classList.remove('d-none');
		// 			overlay.classList.remove('d-none');
		// 			document.body.classList.add('modal-open');
		// 		}, 30000); // 30 seconds
		// 	}

		// 	document.querySelectorAll('.js-conditions-popup-close').forEach(button => {
		// 		button.addEventListener('click', function (e) {
		// 			closeModal();
		// 		});
		// 	});			

		// 	document.querySelector('.js-conditions-popup-survey').addEventListener('click', function (e) {
		// 		e.preventDefault();
		// 		console.log('popup-survey.click:', e);

		// 		window.open(this.href, '_blank');
		// 		// setCookie('viewedSurveyPopup', 'true', 0.0007); // Test ~1 minute
		// 		setCookie('viewedSurveyPopup', 'true', 30); // 30 days

		// 		closeModal();
		// 	});


		// 	document.querySelector('.js-conditions-popup-overlay').addEventListener('click', function () {
		// 		closeModal();
		// 	});

		// } 

		if (reportType != reportTypeEnum.trail) {
			var $paneContainer = $('.js-pane-container-report');
			var $stickyFilters = $('.js-sticky-filter');
			var $filterAccordionBody = $('.js-accordion-filter-body');
			var $filterChevron = $('.js-filter-chevron');
			var $filterHeight = $('.js-filter-height');
			var $subpaneBack = $('.js-subpane-back');

			
			let debounceTimer;
			let filterScrolledTop = true;
			const offset = 10;

			if (isLargeLayout() === true) { 
				$paneContainer.on('scroll', function () {
					clearTimeout(debounceTimer);
					debounceTimer = setTimeout(function() {
						handleScroll();
					}, 5);
				});
				$subpaneBack.on('click', function () {
					$stickyFilters.removeClass('slide-down').addClass('slide-up');
					$filterHeight.removeClass('opacity-0').addClass('opacity-1');
				});
			}
			
			function handleScroll() {
				const scrollTop = $paneContainer.scrollTop();
				var elementHeight = $filterHeight.height();

				if (scrollTop > (elementHeight - offset)) {
					if (filterScrolledTop) {
						setTimeout(function() {
							$stickyFilters.removeClass('slide-up').addClass('slide-down');
							$filterHeight.removeClass('opacity-1').addClass('opacity-0');
							filterScrolledTop = false;
							toggleChevronDirection('down');
						}, 5);
					}
				} 
				else if (scrollTop <= (elementHeight + offset)) {
					$stickyFilters.removeClass('slide-down').addClass('slide-up');
					
					setTimeout(function() {
						if (!filterScrolledTop) {
							$filterHeight.removeClass('opacity-0').addClass('opacity-1');
							$filterAccordionBody.removeClass('active');
							filterScrolledTop = true;
							toggleChevronDirection('down');
						}
					}, 5);
				}
			}
			function toggleChevronDirection(direction) {
				if (direction === 'down') {
					$filterChevron.addClass('fa-chevron-down').removeClass('fa-chevron-up');
				} else if (direction === 'up') {
					$filterChevron.addClass('fa-chevron-up').removeClass('fa-chevron-down');
				}
			}
		} else {
			var $paneContainer = $('.js-pane-container-report');
			var $stickyFilters = $('.js-sticky-filter');
			var $filterAccordionBody = $('.js-accordion-filter-body');
			var $filterChevron = $('.js-filter-chevron');
			var $filterHeight = $('.js-filter-height');
			var $subpaneBack = $('.js-subpane-back');

			
			let debounceTimer;
			let filterScrolledTop = true;
			const offset = 10;

			if (isLargeLayout() === true) { 
				$paneContainer.on('scroll', function () {
					clearTimeout(debounceTimer);
					debounceTimer = setTimeout(function() {
						handleScroll();
					}, 5);
				});
				$subpaneBack.on('click', function () {
					$stickyFilters.removeClass('slide-down').addClass('slide-up');
					$filterHeight.removeClass('opacity-0').addClass('opacity-1');
				});
			}
			
			function handleScroll() {
				const scrollTop = $paneContainer.scrollTop();
				var elementHeight = $filterHeight.height();

				if (scrollTop > (elementHeight - offset)) {
					if (filterScrolledTop) {
						setTimeout(function() {
							$stickyFilters.removeClass('slide-up').addClass('slide-down');
							$filterHeight.removeClass('opacity-1').addClass('opacity-0');
							filterScrolledTop = false;
							toggleChevronDirection('down');
						}, 5);
					}
				} 
				else if (scrollTop <= (elementHeight + offset)) {
					$stickyFilters.removeClass('slide-down').addClass('slide-up');
					
					setTimeout(function() {
						if (!filterScrolledTop) {
							$filterHeight.removeClass('opacity-0').addClass('opacity-1');
							$filterAccordionBody.removeClass('active');
							filterScrolledTop = true;
							toggleChevronDirection('down');
						}
					}, 5);
				}
			}
			function toggleChevronDirection(direction) {
				if (direction === 'down') {
					$filterChevron.addClass('fa-chevron-down').removeClass('fa-chevron-up');
				} else if (direction === 'up') {
					$filterChevron.addClass('fa-chevron-up').removeClass('fa-chevron-down');
				}
			}			
		}

		//TODO: THROTTLE CLICKS SO USER DOESN'T STACK UP REQUESTS
		$('.js-report-button').on('click', function () {
			var route = $(this).data("route");
			var subcode = $(this).data("subcode");
			reportType = route;
			reportSubcode = subcode;
			var useRoute = (reportSubcode) ? reportSubcode : reportType;
			if (_log) console.log('.js-report-button.click');
			if (_log) console.log(activeRoute + ' vs ' + useRoute);
			//Data layer
			//console.log('.js-report-button - REPORT TYPE:', reportType);
			//console.log('.js-report-button - BASE CATEGORY:', baseCategory);

			checkReportType();

			//clear out any other active report or subpane buttons
			clearActive($subpaneButtons);
			//close any open subpanes
			closeSubpanes();
			//open pane if it's closed
			openPane();
			tw.ConditionReportsListings.showReports();
			$('body').removeClass('is-hidden-map');
			$('.js-pane-header').removeClass('hidden');

			$('.js-clear-search').addClass('hidden');
			$('.js-filter-search').val('');

			$('.js-reports-filter, .js-reports-filter23').each(function () {
				$(this).prop('checked', false);
				$(this).parent().removeClass('active');
			});

			$('.js-reports-filter, .js-reports-sort').each(function () {
				$(this).prop('checked', false);
				$(this).parent().removeClass('active');
			});

			if (activeRoute != useRoute) {

				//todo-jk: check this out and make sure it still works
				activeRoute = useRoute;

				var txt = useRoute,
					href = useHref,
					obj = {
						path: href,
						text: txt
                    };

                tw.ConditionReportsListings.showAllReports();

				// if(reportType == 'snowmobile'){
				// 	$('.js-condition-fair').addClass('hidden');
				// } else {
				// 	if($('.js-condition-fair').length) $('.js-condition-fair').removeClass('hidden');
				// }

				clearActive($reportButtons);
				//set this report to active and make sure the pane is open
				// console.log('setactive->', $(this).attr('data-subpane'));
				// setActive($(this).attr('data-subpane'));
                $(this).addClass('is-active');

			    //tw.Analytics.trackPageview(getReportTitle('gaShort'));
                //tw.Analytics.setPageview(basePath + '/' + route);

				if (_log) console.log('window.history.pushState(' + JSON.stringify(obj) + ', ' + txt + ', ' + href + ')');
                window.history.pushState(obj, txt, href);

				changeUrl();

			} else {

                BingMap.Map.softResetMap();

                if (tw.ConditionReportsListings.isStatusFiltered() === true) {
                    tw.ConditionReportsListings.showAllReports();
                    tw.ConditionReportsListings.toggleVisibleStatusReports();
                }
			}

			tw.Analytics.ga4(baseCategory, getReportTitle('gaLong'), '');

        });

        $toolbarSecondaryButtons.click(function () {
            var thisId = $(this).attr('data-subpane');
            clearActive($toolbarSecondaryButtons);
            //automatically collapse the secondary tools and map on mobile for more room
            showFewerTools();
            hideMap();

            setActive(thisId);
			$('.js-pane-header').addClass('hidden');
        });

		$('body').on('click', '.js-info-fcr', function () {
			$('.js-pane-header').addClass('hidden');
		});

		$('body').on('click', '.js-report-expand', function () {
            tw.ConditionReportsListings.expandReports($(this));

            /* not very elegant, but if we're coming from a local listing of reports instead of the main list, let's make sure we get back there */

			$('.js-pane-header').addClass('hidden');

            var detailBack = $('.js-subpane[data-subpane="report-detail"]').find('.js-subpane-back');
			if(isSnowReport) {
				detailBack.each(function() {
					$(this).html('<i class="fas fa-long-arrow-alt-left mr-2"></i>Back to List');
				});
			} 
			else {
				if ($(this).parents('.js-local-container').length > 0) {
					detailBack.attr('data-subpane', 'reports-local');
					detailBack.each(function() {
						if (reportType == reportTypeEnum.fallcolor) {
							$(this).html('<i class="fas fa-long-arrow-alt-left mr-2 text-quaternary"></i>Back');
						} else {
							if ($(this).text() === "Close") {
								$(this).text('Back');
							}
						}
					});
				} else {
					detailBack.removeAttr('data-subpane');
					detailBack.each(function() {
						if (reportType == reportTypeEnum.fallcolor) {
							$(this).html('<i class="fas fa-long-arrow-alt-left mr-2 text-quaternary"></i>Back');		
						} else {
							if ($(this).text() === "Back") {
								$(this).text('Close');
							}
						}
					});
				}
			}

			var loc = $(this).data('title');
			var addReportTypeForSCR = '';
			if (reportType != reportTypeEnum.fallcolor) {
				addReportTypeForSCR = ' - ' + getReportTitle('gaShort')
			}
			if (baseCategory == 'Biking Report' || baseCategory == 'Hiking Report') {
				tw.Analytics.ga4('Trail Report', 'Location Click' + addReportTypeForSCR, loc);
				// console.log('location-click: ', 'Trail Report', 'Location Click' + addReportTypeForSCR, loc);
			} else {
				tw.Analytics.ga4(baseCategory, 'Location Click' + addReportTypeForSCR, loc);
				// console.log('location-click: ', baseCategory, 'Location Click' + addReportTypeForSCR, loc);
			}
		});

		/**
		 * analytics tracking event
		 */
		$('.js-analytics-event').on('click', function () {
			// console.log('.js-analytics-event.click');
			var action = $(this).data('event-action');
			var label = ($(this).data('event-label') != null) ? $(this).data('event-label') : '';

			var gaShort = $(this).attr('data-ga');

			//Data layer
			tw.Analytics.ga4(baseCategory, action + gaShort, label);
			/*console.log('js-analytics-event: ', baseCategory, action + gaShort, label);*/
						
		});


		$('.js-reset-map').on('click', function () {
			BingMap.Map.softResetMap();
		});

		$('body').on('click', '.js-getinspired', function () {
			openFcrVideoModal();
			tw.Analytics.ga4(baseCategory, 'Get Inspired', 'Open Video');

			// console.log('js-getinspired:', baseCategory, 'Get Inspired', 'Open Video');
		});

		$('body').on('click', '.js-gallery-photo', function () {
			var indexYear = $(this).data('index-year'),
				indexPhoto = $(this).data('index-photo'),
				photo = gallery.Years[indexYear].Images[indexPhoto];
			if (_log) console.group('$(.js-gallery-thumb__figure).click()');
			if (_log) console.log(indexYear, indexPhoto, photo);
			if (_log) console.groupEnd();
			getPhotoDetails(photo.ID);

			//Data layer
			tw.Analytics.ga4(baseCategory, 'Photo Gallery', 'Open Photo');
			/*console.log('js-gallery-photo:', baseCategory, 'Photo Gallery', 'Open Photo');*/
		});

		$('body').on('click', '.js-photo-nav', function () {
			//if (_log) console.group('$(.js-gallery-thumb__figure).click()');
			var id = $(this).data('getid');
			if (_log) console.log('getid:', id);
			if (_log) console.groupEnd();

			if (id > 0) {
				var btn = ($(this).hasClass('next')) ? 'Next': 'Previous';
				getPhotoDetails(id);
				tw.Analytics.ga4(baseCategory, baseAction + ' Photo Gallery', btn);
			}
        });

        $('body').on('click', '.js-location-photo-open', function () {
            //if (_log) console.group('$(.js-gallery-thumb__figure).click()');
			var id = $(this).data('id'),
				title = $(this).data('title');
			 //if (_log) console.log('id:', id);
			 //if (_log) console.log('title:', title);
            // if (_log) console.groupEnd();

            if (id > 0) {
				var btn = ($(this).hasClass('next')) ? 'Next': 'Previous';
				tw.ConditionReportsListings.getLocationPhotoFromId(id);

				var gaShort = $(this).parent().attr('data-ga');

				//Data layer
				tw.Analytics.ga4(baseCategory, 'Location Photo Open', title + ' Photo');
				/*console.log('js-location-photo-open3: ', baseCategory, 'Location Photo Open', title + ' Photo');*/
            }
		});
		
		$('body').on('click', '.js-location-photo-nav', function () {
            //if (_log) console.group('$(.js-gallery-thumb__figure).click()');
            var id = $(this).data('id');
            if (_log) console.log('id:', id);
			if (_log) console.groupEnd();
			var actionBtnDirection = '';
			var label = '';

            if (id > 0) {
				var btn = ($(this).hasClass('next')) ? 'Next': 'Previous';
				if (btn == 'Next') {
					actionBtnDirection = 'Next Button';
					label = 'Right Arrow Click';
				} else if (btn == 'Previous') {
					actionBtnDirection = 'Previous Button';
					label = 'Left Arrow Click';
				}

				tw.ConditionReportsListings.getLocationPhotoFromId(id);

				var gaShort = $('.js-analytics-event').attr('data-ga');

				//Data layer
				tw.Analytics.ga4(baseCategory, 'Location Photo Click - ' + actionBtnDirection + gaShort, label);
				/*console.log('js-location-photo-nav:', baseCategory, 'Location Photo Click - ' + actionBtnDirection + gaShort, label);*/
            }
		});
		

		// $('body').on('click', '.js-modal-video', function () {
		// 	if (_log) console.group('.js-modal-video.click()');
			
		// });

		//tester btn
		$('.js-modal-video-test').modaal({
			type: 'video',
			background: 'rgba(198, 186, 168, 1)',
			before_open: function() {
				console.log('.js-modal-video before_open');
				console.log('.js-modal-video desc', this.$elem.attr('data-modaal-desc'));
			},
			after_open: function () {
				var captionText = this.$elem.attr('data-modaal-desc');
				var caption = $('<div class="modaal-gallery-label">' + captionText + '</div>');
				$('.modaal-video-wrap').append(caption);
				
			}
		});

		

		//opening subpanes
        $subpaneButtons.click(function () {
			//if (_log) console.log('$subpaneButtons.click');
			checkDestination($(this));
		});


		$('.js-pane-close').click(function () {
			//if (_log) console.log('$(.js-pane-close).click()');
			clearActive($toolbarSecondaryButtons);
			closeSubpanes();
			closePane();

		});

		$('.js-subpane-open-print').click(function () {
			//if (_log) console.log('$(.js-subpane-open-print).click()');
			var useRoute = (reportSubcode) ? reportSubcode : reportType;
			window.open(basePath + '/print' + useRoute, '', 'width=680,height=480');

			var gaShort = $(this).attr('data-ga');

			//Data layer
			tw.Analytics.ga4(baseCategory, 'View & Print' + gaShort, '');
			/*console.log('js-subpane-open-print:', baseCategory, 'View & Print' + gaShort, '');*/
		});

		

		$('.js-toolbar-more').click(function () {
			showMoreTools();
			tw.Analytics.ga4(baseCategory, 'Mobile Toolbar Toggle', 'Show');
		});

		$('.js-toolbar-fewer').click(function () {
			showFewerTools();
			tw.Analytics.ga4(baseCategory, 'Mobile Toolbar Toggle', 'Hide');
		});

		$('.js-toolbar-toggle-menu').on('click', function () {
			var isActive = $(this).hasClass('is-active'),
				toggleLabel = '';
			if(_log) console.log('.js-toolbar-toggle-menu.isActive:', isActive);
			if(isActive) {
				$(this).removeClass('is-active');
				toggleLabel = 'Hide';
				$('.js-toolbar-menu-mobile').addClass('hidden');
			} else {
				$(this).addClass('is-active');
				toggleLabel = 'Show';
				$('.js-toolbar-menu-mobile').removeClass('hidden');
			}
			tw.Analytics.ga4(baseCategory, 'Mobile Toolbar Toggle', toggleLabel);
		});

		$('.js-map-hide').click(function () {
			hideMap();
			tw.Analytics.ga4(baseCategory, 'Mobile Map Toggle', 'Hide');
		});

		$('.js-map-show').click(function () {
			showMap();
			tw.Analytics.ga4(baseCategory, 'Mobile Map Toggle', 'Show');
		});

		$('.js-location').click(function () {
			getUserCoordinates(passCoordinates);
		});

		$('.off-season-modal-trigger').modaal({
			start_open: true,
			background: "#ddd"
		});

		$('#photoDateTaken').datepicker({
			dateFormat: "m/d/yy",
			minDate: new Date(2012, 0, 1),
			maxDate: new Date
		});

		$('.js-filter-bar__mobile-toggle').on('click', function() {
			$(this).toggleClass('show');
			$(this).attr('aria-expanded', function(_, attr) { return !(attr == 'true') })
			
			var dropdown = $(this).siblings();
			dropdown.toggleClass('show');

			var count = 0;
			
			if(!$(this).hasClass('show')) {
				if($('.js-reports-sort:checked').length || $('.js-reports-filter:checked').length) {
					if($('.js-reports-sort:checked').length){
						count++;
					}

					if($('.js-reports-filter:checked').length){
						count += $('.js-reports-filter:checked').length;
					}

					$('.js-filter-bar__mobile-toggle-copy')
						.removeClass("selected1")
						.removeClass("selected2")
						.removeClass("selected3")
						.addClass("selected" + count);
				} else {
					$('.js-filter-bar__mobile-toggle-copy')
						.removeClass("selected1")
						.removeClass("selected2")
						.removeClass("selected3");
				}
			}
		})

		$('.js-dropdown-checkbox').on('change', function () {
			var checkedCount = $('.js-dropdown-checkbox:checked').length;
			$('.js-count').text('(' + checkedCount + ')');

			if ($(this).is(':checked')) {
				$(this).closest('label').addClass('is-active');
			} else {
				$(this).closest('label').removeClass('is-active');
			}
		});

		$('.dropdown-button').on('click', function () {
			$(this).find('.fas').toggleClass('fa-chevron-up fa-chevron-down');
			$(this).siblings('.dropdown-menu').toggle();
		});

		$(document).ready(function() {
			$('#toggleYoutube').prop('checked', true).trigger('change');
			$('#togglePOI').prop('checked', true).trigger('change');
		});

		$('.js-reports-filter').on('change', function () {
			var thisFilter = $(this).attr('data-filter'),
				isChecked = $(this).is(':checked'),
				isActivityFilter = $(this).hasClass('js-activity') ? true : false;
			// console.log('.js-reports-filter reportType:', reportType);
			// console.log('.js-reports-filter thisFilter:', thisFilter);
			// console.log('.js-reports-filter isChecked:', isChecked);
			// console.log('.js-reports-filter isActivityFilter:', isActivityFilter);

			$('.js-reports-filter').each(function () {
				if ($(this).attr('data-filter') === thisFilter) {
					$(this).prop('checked', isChecked);
				}
			});			
			if(isActivityFilter && isChecked) {
				$('.js-activity').each(function() {
					var loopFilter = $(this).attr('data-filter');
					if(loopFilter != thisFilter) $(this).prop('checked', false);
				});
				console.log('.js-reports-filter set to unchecked!');
			}
			tw.ConditionReportsListings.toggleVisibleStatusReports(reportType);
		});



		var sto = null;//search timeout

		$('.js-filter-search').on('input', function() {
			// console.log('.js-filter-search.input happened');
			clearTimeout(sto);
			sto = setTimeout(() => {
				var $this = $(this);
				// console.log('.js-filter-search:', $(this).val());
				var filter = normalizeText($this.val());
				// console.log('.js-filter-search.length:', filter.length);

				var isFilterActive = filter.length > 0;
					// console.log('.js-filter-search.filter:', filter);
				$('.js-filter-search').not($this).val(filter);
				if (isFilterActive) {
					$('.js-clear-search').removeClass('hidden');
				} else {
					$('.js-clear-search').addClass('hidden');
				}

				tw.Analytics.ga4(baseCategory, 'Location Search', filter);
				$('.js-filter-search').data('search-filter', filter);
				tw.ConditionReportsListings.toggleVisibleStatusReports(reportType);
			}, 1000);

		});

		$('.js-clear-search').on('click', function() {
			$('.js-filter-search').val('').trigger('input');
			$(this).addClass('hidden');
		});

		$('.js-reports-filter23').on('change', function () {
			var thisFilter = $(this).attr('data-filter'),
				isChecked = $(this).is(':checked'),
				isActivityFilter = $(this).hasClass('js-activity') ? true : false;

			$('.js-reports-filter23').each(function () {
				if ($(this).attr('data-filter') === thisFilter) {
					$(this).prop('checked', isChecked);
				}
			});

			if(isActivityFilter && isChecked) {
				$('.js-activity').each(function() {
					var loopFilter = $(this).attr('data-filter');
					if(loopFilter != thisFilter) $(this).prop('checked', false);
				});
			}
			tw.ConditionReportsListings.toggleVisibleStatusReports(reportType);
		});

		$('input[name="filter-weeks-to-peak"]').click(function(){
			var $radio = $(this);

			$radio.closest('.filter-bar__dropdown-menu').removeClass('show');

			$('.js-filter-bar__dropdown-toggle-copy').html($radio.siblings().html());

			tw.ConditionReportsListings.toggleVisibleStatusReports(reportType);
		});

		// console.log('.js-reports-sort.len', $('.js-reports-sort').length);
		$(document).on('change', '.js-reports-sort', function () {
			//console.log('.js-reports-sort reportType:', reportType);
			var thisFilter = $(this).attr('data-filter'),
				isChecked = $(this).is(':checked')

			$('.js-reports-sort').each(function () {
				if ($(this).attr('data-filter') === thisFilter) {
					$(this).prop('checked', isChecked);
				}
			});			
			tw.ConditionReportsListings.sortVisibleStatusReports(reportType);
		});

		$('.js-filter-bar__dropdown-toggle').on('click', function() {
			var $this = $(this);
			var $dropdown = $this.siblings();
			var $chevronIcon = $this.find('.js-filter-bar__dropdown-toggle-icon');

			$this.toggleClass('show');
			$this.attr('aria-expanded', function(_, attr) { return !(attr == 'true') });
			$dropdown.toggleClass('show');

			if ($chevronIcon.hasClass('fa-chevron-down')) {
				$chevronIcon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
			} else {
				$chevronIcon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
			}
		});

		var loadedPhotos = false;
		$('.js-subpane-button[data-subpane="gallery"]').on('click', function () {
			
			if (reportType == reportTypeEnum.trail){
				if(!loadedPhotos) {
					tw.ConditionReportsListings.initializeUGC("cr-init__7f5682a0bd7f2fea", "photoGallery");
				}
				loadedPhotos = true;
				
			} else if (isSnowReport) {
				if(!loadedPhotos) {
					tw.ConditionReportsListings.initializeUGC("cr-init__fe416ea2f04e8a38", "photoGallery");
				}
				loadedPhotos = true;

			} else {
				//if gallery doesn't exist yet, go get data
				if (gallery.length < 1 && reportType == reportTypeEnum.fallcolor) {
					getPhotoGallery(0);
				}
			}
        });

		$('body').on('click', '.js-pane__image-modal-trigger', function(e) {
			e.preventDefault();
			var modalId = $(this).attr("href").replace("#", "");

			$(".js-pane__image-modal[data-modal-id='" + modalId + "']").dialog({
				resizable: true,
				height: "auto",
				width: "auto",
				modal: true,
				position: {
					my: "center center",
					at: "center center",
					of: window
				},
				create: function( event, ui ) {
					//console.log('create', event, ui);
					$(this).css("minWidth", "300px");
					$(this).css("maxWidth", "975px");
					$(this).css("maxHeight", "800px");
				}
			});
		})

        /* Need to rearrange the nav to allow the open nav to not be fixed, otherwise users can't get to off-screen nav items */
        $('.js-global-nav').appendTo('.js-header-container');

        $('.js-navbar-toggle').click(function () {
            $(window).scrollTop(0);
		});
		
		/* These are taken out of layout.js as including that file in its entirety doesn't seem to work */
		/* TODO: clean this up */
        wdot.City.loadCityAutocompleteForPublicSite($(".citiesRegionsSearch"), ".cityAutoComplete");
        wdot.City.loadCityAutocompleteForPublicSite($(".eventsDropdown"), ".cityFilterAutoComplete");

        $(".menu-destination-search").submit(function () {
            var url = "";
            var searchString = "";
            var appendCityOrCounty = "";

            if (($("input[name='CityCitiesAndRegions']").data("cityurl")) !== "") {
                searchString = $("input[name='CityCitiesAndRegions']").val();
                appendCityOrCounty = "City: ";
                url = $("input[name='CityCitiesAndRegions']").data("cityurl");
            } else if (($("input[name='County']").data("countyurl")) !== "") {
                searchString = $("input[name='County']").val();
                appendCityOrCounty = "County: ";
                url = $("input[name='County']").data("countyurl");
            }

            ga('send', 'event', 'Top Navigation', 'Cities and Regions', appendCityOrCounty + searchString);

            if (url != undefined && url != "") {
                window.location = url;
            }

            return false;
        });

        //sharing

        $('.js-share-pinterest').click(function () {
			if (reportType == reportTypeEnum.fallcolor) {
				share.Pinterest('/fall-color-report', 'page', 'Fall Color Report | Travel Wisconsin | 2019 Fall Color Map', '/images/fcr/2012/fall-leaves.jpg');
			} else {
				share.Pinterest('/snowreport', 'page', 'Wisconsin Snow Report | Travel Wisconsin | Snow Conditions Map', '/images/snow-report/submit.jpg');
			}
        });

        $('.js-share-facebook').click(function () {
			// console.log('SHARE reportType:', reportType);
			// console.log('SHARE reportSubcode:', reportSubcode);
			// console.log('SHARE vs:', reportSubcodeEnum.hiking);
			if(reportType == reportTypeEnum.trail) {
				if(reportSubcode.toLowerCase() == reportSubcodeEnum.hiking) {
					share.Facebook('/hiking-report');
				} else{
					share.Facebook('/biking-report');
				}

			} else if (reportType == reportTypeEnum.fallcolor) {
				share.Facebook('/fall-color-report');
			} else {
				share.Facebook('/snowreport');
			}
            
        });

        $('.js-share-twitter').click(function () {
			if(reportType == reportTypeEnum.trail) {
				if(reportSubcode.toLowerCase() == reportSubcodeEnum.hiking) {
					share.Twitter('/hiking-report', 'page', 'Wisconsin Hiking Trail Report | Travel Wisconsin');
				} else{
					share.Twitter('/biking-report', 'page', 'Wisconsin Biking Trail Report | Travel Wisconsin');
				}

			} else if (reportType == reportTypeEnum.fallcolor) {
				share.Twitter('/fall-color-report', 'page', 'Fall Color Report | Travel Wisconsin | 2020 Fall Color Map');
			} else {
				share.Twitter('/snowreport', 'page', 'Wisconsin Snow Report | Travel Wisconsin | Snow Conditions');
			}
            
        });

        // $('body').on('click', '.js-share-submit', function () {
        //     //console.log("click share");
        //     shareByEmail($(this));
        // });

        $('body').on('click', '.js-share-reset', function () {
			resetFormShare();
            //for bringing back the share by email form after a submission
            // var formContainer = $('.js-share-form-container');
            // $.ajax(
            //     {
            //         url: basePath + '/email',
            //         success: function (data) {
            //             formContainer.html(data);
            //         },
            //         error: function (xhr, status, error) {
            //             console.log(xhr, status, error);
            //         }
            //     }
            // )
        });

		initializeCityAutocomplete($("#sourceLoc"));
		initializeFormUserSubmission();
		initializeShareEmail();
		
		$(window).on('scroll', function () {
			var currentPos = window.scrollY;

            var body = $('body');
			var conditionsHeading = $('.js-report-statuses').outerHeight();
			if (currentPos > conditionsHeading) {
				body.addClass('fixed');
			} else if ((currentPos < conditionsHeading) && isLargeLayout() === false) {
                //only do this on mobile
                body.removeClass('fixed'); 
			}
		});

		var prevScrollpos = window.scrollY;
		
		$(window).on('scroll', function() {
			var currentScrollPos = window.scrollY;
			
			if (prevScrollpos <= currentScrollPos && currentScrollPos > 250) {
				if($('.js-filter-bar__mobile-toggle').hasClass('show')){
					$('.js-filter-bar__mobile-toggle').removeClass('show');
					$('.js-filter-bar__mobile-toggle').siblings().removeClass('show');

					var count = 0;

					if($('.js-reports-sort:checked').length || $('.js-reports-filter:checked').length) {
						if($('.js-reports-sort:checked').length){
							count++;
						}
	
						if($('.js-reports-filter:checked').length){
							count += $('.js-reports-filter:checked').length;
						}
	
						$('.js-filter-bar__mobile-toggle-copy')
							.removeClass("selected1")
							.removeClass("selected2")
							.removeClass("selected3")
							.addClass("selected" + count);
					} else {
						$('.js-filter-bar__mobile-toggle-copy')
							.removeClass("selected1")
							.removeClass("selected2")
							.removeClass("selected3");
					}
				}
			}

			prevScrollpos = currentScrollPos;
		})

		$(window).smartresize(function() {
			if (_log) console.log('smartresize.initLoadResize:', initLoadResize);
			if (!initLoadResize) {
				BingMap.Map.trackResize();
			}
			initLoadResize = false;

			//since layout was changed to scroll reports only, desktop is now always fixed
			if (isLargeLayout() === true) {
				$('body').addClass('fixed');
			}
        }).resize();

        checkToolbarHeight($toolbar);

		if (isLargeLayout() === true) {
			$('body').addClass('fixed');
		} else {
			$('body').removeClass('fixed');
		}

        //tw.Analytics.trackPageview(getReportTitle('gaShort'));

		if (_log) console.groupEnd();

	};




	/**
	 * Check for Deeplink, load details if found
	 */
	var checkForDeeplink = function () {
		if (_log) console.log('checkForDeeplink() LOOK FOR DEEPLINK');
		
		if (urlParams && urlParams['type'] != null && urlParams['id'] != null && urlParams['id'] > 0) {
			if (_log) console.log('DEEPLINK TO REPORT.ID: ', urlParams['id']);
			var id = urlParams['id'],
				maxCheck = 30;
			
			var deepInt = setInterval(function () {
				var btn = $('button[data-id="' + id + '"]'),
					title = $(btn).data('title');
				if (_log) console.log('btn.title: ', title);
				if (_log) console.log('btn.width():', btn.width());

				if (btn.width() > 5) {//btn now exists, open report
					tw.ConditionReportsListings.expandReports(btn);
					clearInterval(deepInt);

					var addReportTypeForSCR = '';
					if (reportType != reportTypeEnum.fallcolor) {
						addReportTypeForSCR = ' - ' + getReportTitle('gaShort')
					}
					tw.Analytics.ga4(baseCategory, 'Deep Link' + addReportTypeForSCR, title);
				}
				//try to find it for a bit, but then stop looking
				maxCheck --;
				if (maxCheck == 0) {
					clearInterval(deepInt);
				}
			}, 400);
		}

	}


	/**
	 * (RE)Initialize Map, only called once
	 * Get Counties Shape data before initializing map
	 * */
	var initializeMap = function (reportType, reportSubcode) {
		if (_log) console.log('initializeMap()');
		BingMap.Map.initializeMap({
			ReportType: reportType,
			ReportSubcode: reportSubcode,
			CountyData: $("[data-countydata]").data("countydata")
		});
		checkForDeeplink();
	};

	function normalizeText(text) {
		return text
			.toLowerCase()
			.replace(/[\u2018\u2019]/g, "'") // smart quotes
			.replace(/'/g, '')              // remove all apostrophes
			.replace(/\s+/g, ' ')            // collapse spaces
			.trim();
	}

	/**
	 *Change url, update nav, pagetitle, get map, update panes
	 */
	var changeUrl = function () {
		if (_log) console.log('changeUrl()');
		
		updatePageTitle();
		updateDataGa();
		BingMap.Map.deletePhotoInfoboxes();
		initializeMap(reportType, reportSubcode); //initmap before region, updates reportType
		tw.ConditionReportsListings.emptyReportDetails();
		tw.ConditionReportsListings.getAllReportsByRegion();
	};



	/**
	 * Get report title
	 */
	var getReportTitle = function (type) {
		// if (_log) console.group('tw.ConditionsReports.getReportTitle()');
		// if (_log) console.log('reportType', reportType); 
		// if (_log) console.log('reportSubcode', reportSubcode); 
		// if (_log) console.log('type', type); 
		var title = (reportSubcode) ? reportTitles[reportSubcode.toLowerCase()][type] : reportTitles[reportType][type];
		// if (_log) console.log('title:', title);
		// if (_log) console.groupEnd();
		return title;
	}



	/**
	 * Update page title
	 */
	var updatePageTitle = function () {
		if (_log) console.log('updatePageTitle()');
		var reportTitle = getReportTitle('pageTitle');
		var reportDesc = getReportTitle('description');
		var pageTitle = reportTitle + ' ' + decodeURIComponent(baseTitle);
		// console.log('pageTitle: ', pageTitle);
		// console.log('reportDesc: ', reportDesc);
		document.title = pageTitle;
		if(reportDesc != undefined) {
			document.querySelector('meta[name="description"]').setAttribute("content", reportDesc);
			document.querySelector('meta[property="og:description"]').setAttribute("content", reportDesc);
		}
		

		if(isSnowReport) {
			var protohost = location.protocol + '//' + location.host;
			var ogImage = decodeURIComponent(ogImages[reportType]);
			//console.log('protohost: ', protohost);
			//console.log('ogImage:: ', ogImage);
			$('meta[property=og\\:image]').attr('content', protohost + ogImage);
		}
		
	};

	var updateDataGa = function () {
		var gaShort = getReportTitle('gaShort');
		var gaShortElements = document.querySelectorAll('[data-ga]');
		
		gaShortElements.forEach(function (gaShortElement) {
			gaShortElement.setAttribute('data-ga', ' - ' + gaShort);
		});
	}







	//AJAX GETTERS




	/**
	 * Get Photo Gallery
	 * THIS HAS BEEN RETIRED FOR CROWDRIFF
	 */
	var getPhotoGallery = function (count, callback) {
		if (_log) console.log('getPhotoGallery()', reportType);

		$.ajax({
			url: basePath + '/getuserphotosubmissions',
			type: "POST",
			data: {
				reportType: reportType,
				max: count
			},
			success: function (data) {
				if (_log) console.log('getPhotoGallery.data: ', data);
				addPhotoGallery(data);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			},
			complete: function () {
				if (callback) {
					callback();
				}
			}
		});
	};



	/**
	 * Get Photo Details
	 */
	var getPhotoDetails = function (id) {
		if (_log) console.log('getPhotoDetails()', id, reportType);

		$.ajax({
			url: basePath + '/getuserphotodetails',
			type: "POST",
			data: {
				reportType: reportType,
				id: id
			},
			success: function (data) {
				if (_log) console.log('photoDetails.data: ', data);
				addPhotoDetails(data);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			},
			complete: function () {
				// if (callback) {
				// 	callback();
				// }
			}
		});
	};


	/**
	 * Get City from Coordinates
	 */
	var getCityFromCoordinates = function (lat, lon, callback) {
		if (_log) console.log('getCityFromCoordinates()', lat, lon);
		jQuery.ajax({
			url: '/snowreport/getnearestcitybylatlong',
			type: "POST",
			data: {
				latitude: lat,
				longitude: lon
			},
			success: function (data) {
				callback(data.City);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			}
		});
	}






	//DECORATE STAGE


	/**
	 * Add photo gallery images to stage
	 */
	var addPhotoGallery = function (data) {
		if (_log) console.group('addPhotoGallery()');
		if (_log) console.log('data:', data);
        gallery = data; //hold data

		var yearsArr = data.Years,
			html = '',
			compiledTemplateHead = Template7.compile(photoYearHeaderTemplate),
			compiledTemplateThumb = Template7.compile(photoThumbTemplate);



		for (var y = 0; y < yearsArr.length; y++) {
			if (_log) console.log(y, yearsArr[y].Year, yearsArr[y].Images.length);
			//add year header

			var jsonContentHead = {
				Year: yearsArr[y].Year
			};
            var newHeader = compiledTemplateHead(jsonContentHead);
            $('#photoGallery').append(newHeader);

            var newContainer = $('#photoGallery .js-container')
                .eq(0)
                .clone()
                .html('');

			for (var i = 0; i < yearsArr[y].Images.length; i++) {
				var photo = yearsArr[y].Images[i],
					caption = '';

				if (photo.ImageTitle != null && photo.ImageTitle != '') {
					caption = photo.ImageTitle;
				} else if (photo.City != '') {
					caption = photo.City;
				} else {
					caption = photo.ImageSrc;
                }

				var jsonContent = {
					indexYear: y,
					indexPhoto: i,
					Caption: caption,
					Id: photo.ID,
					Latitude: photo.Latitude,
					Longitude: photo.Longitude,
					ImageSrc: imgBaseUrl + photo.ImageSrc
                };

                newContainer.append(compiledTemplateThumb(jsonContent));
				//if (_log) console.log('jsonContent:', jsonContent);

            }

            $('#photoGallery').append(newContainer);

        }

        //don't need the container example anymore
        $('#photoGallery .js-container').eq(0).remove();

		//force LazyLoad to update after the DOM changes
		crLazyLoad.update();
		if (_log) console.log('crLazyLoad.update()');

		if (_log) console.groupEnd();
	}



	/**
	 * Add photo details
	 * @param {*} data
	 */
	var addPhotoDetails = function (photo) {
		if (_log) console.log('addPhotoDetails()', photo);

		var compiledTemplate = Template7.compile(photoDetailTemplate),
			caption = '';

		if (photo.ImageTitle != null && photo.ImageTitle != '') {
			caption = photo.ImageTitle;
		} else if (photo.City != '') {
			caption = photo.City;
		} else {
			caption = photo.ImageSrc;
		}

		var jsonContent = {
			City: photo.City,
			Caption: caption,
			Comments: photo.Comments,
			Id: photo.ID,
			Latitude: photo.Latitude,
			Longitude: photo.Longitude,
			ImageDateTaken: photo.ImageDateTaken,
			//ImageDateDisplay: dateDisplay,
			ImageSrc: imgBaseUrl + photo.ImageSrc,
			ImageTitle: photo.ImageTitle,
			UserName: photo.UserName,
			NextPhotoID: photo.NextPhotoID,
			PreviousPhotoID: photo.PreviousPhotoID
		};
		//if (_log) console.log('jsonContent:', jsonContent);
		var html = compiledTemplate(jsonContent);
		$('#photoDetails').html(html);

        openSubpane({ subpane: 'gallery-detail' });

        BingMap.Map.infoboxPhotoPinPlacement(photo);
    }

    var checkDestination = function (button) {
        var thisSubpane = button.attr('data-subpane'),
            //optional ID of subpane to return to
			returnTo = button.attr('data-return');

		/* If returnTo is true, get the ID of the last report pane user was on and send them back there */
			
		if (returnTo === "true") {
			thisSubpane = getPaneRecords();
		}

        //if button does not specify a subpane to open (e.g. subpane back buttons) then show the reports
        if (thisSubpane) {
            openSubpane({
                subpane: thisSubpane,
                returnTo: returnTo
            });
        } else {
            closeSubpanes();
            clearActive($toolbarSecondaryButtons);
            BingMap.Map.softResetMap();
            tw.ConditionReportsListings.showReports();
			$('.js-pane-header').removeClass('hidden');
        }
    }


    var isLargeLayout = function () {
        //if (_log) console.log('isLargeLayout()');

        var breakpoint = window.matchMedia("(min-width: 1023px)").matches === true;

        return breakpoint;
	}
	
	var setPaneRecords = function(subpaneId) {
		if (subpaneId) { 
			currentReportPane = subpaneId;
		} else {
			/* If it's all reports, then it will have no subpaneId */
			currentReportPane = undefined;
		}
	}

	var getPaneRecords = function() {
		return currentReportPane;
	}


	var openSubpane = function (options) {
        //if (_log) console.log('openSubpane.options', options);
        var subpaneId = options.subpane,
			$thisSubpane = $subpanes.filter('[data-subpane="' + subpaneId + '"]');

        //don't do anything if a valid subpane ID hasn't been provided

        if ($thisSubpane.length > 0) {

            //only one subpane can be open at a time
            closeSubpanes();

            //the pane has to be open if a subpane is open
            openPane();

            if ($thisSubpane.hasClass('is-hidden')) {
                $thisSubpane.removeClass('is-hidden');
			}
			
			if (subpaneId == 'share') {
				//update form URL hidden input
				resetFormShare();
			}

            BingMap.Map.deletePhotoInfoboxes();

            /* if (options.returnTo) {
                console.log("return to :" + options.returnTo);
                var $thisSubpaneBack = $thisSubpane.find('.js-subpane-back');
                    $thisSubpaneBack.attr('data-subpane',options.returnTo);
            } */

            tw.ConditionReportsListings.hideReports();

        }

        //return to the top of the page in case we were scrolled down a long list
        if (isLargeLayout() === true) {
            $(window).scrollTop(0);
        } else {
            //on mobile only go as far up as is necessary to get past the toolbar
            var scrollDistance = $toolbar.height() - 50;
			// console.log('scrollDistance:', scrollDistance);
            $(window).scrollTop(scrollDistance);
        }

	};



	/**
	 * Reset all Panes, give access to external files
	 */
	var resetAllPanes = function () {
		clearActive($subpaneButtons);
		clearActive($toolbarSecondaryButtons);
		closeSubpanes();
		openPane();
        tw.ConditionReportsListings.showReports();
	}

	var closeSubpanes = function () {
		//console.log('closeSubpanes()');
        $subpanes.addClass('is-hidden');
	}

	var setActive = function (subpaneId) {
        //console.log("setting active button: " + subpaneId);
		//find buttons that belong to the currently active pane and make them active, even if they weren't the button used to launch the pane
		$subpaneButtons.filter('[data-subpane="' + subpaneId + '"]').addClass('is-active');
	}

	var clearActive = function (buttons) {
		//console.log('clearActive()');
		buttons.removeClass('is-active');
	}

	var openPane = function () {
		//console.log('openPane()');
		if ($pane.hasClass('is-hidden')) {
			$pane.removeClass('is-hidden');
		}
	}

	var closePane = function () {
		//console.log('closePane()');
		if (!$pane.hasClass('is-hidden')) {
			$pane.addClass('is-hidden');
		}
	}

	var getPaneInfo = function () {
		var json = {
			'isOpen': !$pane.hasClass('is-hidden'),
			'width': $pane.width()
		};
		if(_log) console.log('getPaneInfo: ', json);
		return json;
	}

	var checkToolbarHeight = function(toolbar) {
        if (_log) console.log('checkToolbarHeight()', toolbar);
		if (toolbar.outerHeight() > $(window).height()) {
			toolbar.removeClass('is-fixed');
		} else {
			toolbar.addClass('is-fixed');
		}
	}

	var showMoreTools = function () {
		$extraToolContainer.addClass('is-open');
	}

	var showFewerTools = function () {
		$extraToolContainer.removeClass('is-open');
	}

	var hideMap = function () {
		$('body').addClass('is-hidden-map');
	}

	var showMap = function () {
		$('body').removeClass('is-hidden-map');

	}

	/**
	 * Update city search input
	 */
	var updateCityInput = function (city) {
		if (_log) console.log('updateCityInput()', city);
		$('#sourceLoc').val(city);
		clearSourceLoc();
	}

	var getUserCoordinates = function (callback) {
		if (_log) console.log('getUserCoordinates()');

		function success(position) {
			var location = position;
			var lat = location.coords.latitude;
			var lon = location.coords.longitude;
			callback(lat, lon);
		}
		var error = function () {
			alert("Sorry, we weren't able to determine your location automatically. Please enter it manually in the field and select your city name from the list.")
		};
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(success, error);
		} else {
			error();
		}
	}

	var passCoordinates = function (lat, lon) {
		if (_log) console.log('passCoordinates()', lat, lon);
		getCityFromCoordinates(lat, lon, updateCityInput);
		$('#latitude').val(lat);
		$('#longitude').val(lon);
		//TO DO: Use lat lon to zoom in on map
	}
    
	var initializeCityAutocomplete = function (selector) {
		var citylist = [];
		var i = 0;

		selector.autocomplete({
			source: function (request, response) {
				//CANT PULL THIS OUT. RESPONSE NEEDS TO STAY NESTED WITHIN AUTOCOMPLETE
				$.ajax({
					url: basePath + '/getcitybykeyword',
					dataType: "json",
					data: {
						term: request.term
					},
					success: function (data) {
						console.log('getcitybykeyword().data', data);
						citylist = [];
						i = 0;

						response($.map(data, function (item) {
							if (item) {
								citylist[i] = item;
							}
							i++;
							return {
								label: item.City,
								value: item.City,
								latitude: item.Latitude,
								longitude: item.Longitude
							};
						}));

					},
					error: function (xhr, status, error) {
						console.log(xhr, status, error);
					}
				});

			},
			minLength: 1,
			select: function (event, ui) {
				$("#sourceLoc").val(ui.item.value);
				$("#latitude").val(ui.item.latitude);
				$("#longitude").val(ui.item.longitude);
			},
			focus: function (event, ui) {
				$("#sourceLoc").val(ui.item.value);
				return false;
			},
			close: function (event) {
				//does this function even exist?
				citylist = [];
				i = 0;
				itemSelected = true;
			}
		});

	}


	/**
	 * Clear source location validation upon changes, to revalidate later
	 */
	var clearSourceLoc = function () {
		if (_log) console.log('clearSourceLoc()');
		//clear errors upon changes
		$('#sourceLoc').removeClass('error valid');
		$('#sourceLoc').parent().find('.error').css({'display': 'none'});
	}


	var initializeShareEmail = function() {
		if (_log) console.log('initializeShareEmail()');

		$('body').on('click', '.js-share-submit', function (e) {
            // //console.log("click share");
			// shareByEmail($(this));
			e.preventDefault();
			if (_log) console.log('.js-share-submit.click');
			$('#shareEmail').submit();
        });


		$("#shareEmail").validate({
			ignore: ".ignore",
			rules: {
				YourName: {
					required: function (element) {
						return (!$("#YourName").hasClass('valid'));
					}
				},
				YourEmail: {
					email: true,
					required: function (element) {
						return (!$("#YourEmail").hasClass('valid'));
					}
				},
				FriendName: {
					required: function (element) {
						return (!$("#FriendName").hasClass('valid'));
					}
				},
				FriendEmail: {
					email: true,
					required: function (element) {
						return (!$("#FriendEmail").hasClass('valid'));
					}
				},
				hiddenRecaptcha: {
					required: function () {
						if (grecaptcha.getResponse() == '') {
							return true;
						} else {
							return false;
						}
					}
				}
			},
			submitHandler: function (form) {

				if (_log) console.log('submitHandler()');

				var formSerial = $(form).serialize();
				if (_log) console.log('submitHandler().form: ', formSerial);
				
				$.ajax({
					type: "POST",
					url: basePath + '/email?' + formSerial,
					success: function (data) {
						if(_log) console.log('shareByEmail.success.data:', data);
						//$(form).html(data);
						$('.js-share-thankyou-container').removeClass('hidden');
						$('.js-share-form-container').addClass('hidden');
						tw.Analytics.ga4(baseCategory, 'Share', 'Email');
					},
					error: function (xhr, status, err) {
						console.log(xhr, status, err);
						alert("Sorry! Your submission cannot be processed at this time.")
					}
				});
		


            },
            errorPlacement: function (error, element) {
                error.insertBefore(element);
            }
		});


	}


	var initializeFormUserSubmission = function () {
		if (_log) console.log('initializeFormUserSubmission()');

		//DEV TESTING ONLY
		// $('#userName').val('max power');
		// $('#photoTitle').val('photo Title here');
		// $('#photoDateTaken').val('5/6/78');
		// $('#comments').val('comments');

		$('.js-form-submit').on('click', function (e){
			e.preventDefault();
			if (_log) console.log('.js-form-submit.click');
			$('#formUserSubmission').submit();
		});

		$('.js-twform input[type="text"]').on('keyup', function () {
			if (_log) console.log('.js-twform input[type="text"].keyup');
			//clear errors upon changes
			$(this).removeClass('error valid');
		});
		$('#photoDateTaken').change(function() {
			if (_log) console.log('.js-twform photoDateTaken onchange');
			//clear errors upon changes
			$(this).removeClass('error valid');
			$(this).parent().find('.error').css({'display': 'none'});
		});

		$("#formUserSubmission").validate({
			rules: {
				sourceLoc: {
					required: function (sourceLoc) {
						return (!$("#sourceLoc").hasClass('valid'));
					}
				},
				userName: {
					required: function (element) {
						return (!$("#userName").hasClass('valid'));
					}
				},
				photoTitle: {
					required: function (element) {
						return (!$("#photoTitle").hasClass('valid'));
					}
				},
				photoDateTaken: {
					required: function (element) {
						return (!$("#photoDateTaken").hasClass('valid'));
					}
				},
				realupload: {
					required: function (element) {
						return (!$("#realupload").hasClass('valid'));
					}
				}
			},
			submitHandler: function (form) {

				$('.js-form-submit').hide();//hide button so user doesn't submit twice
				$('#uploadMessages').html('Uploading, please wait...');

				var reqVerifyToken = $('#formUserSubmission input[name="__RequestVerificationToken"]').val();
				if (_log) console.log('submitHandler.reqVerifyToken:', reqVerifyToken);

				var formData = new FormData();
				formData.append("reportType", reportType);
				formData.append("city", $('#sourceLoc').val());
				formData.append("comments", $('#comments').val());
				formData.append("latitude", $('#latitude').val());
				formData.append("longitude", $('#longitude').val());
				formData.append("photoDateTaken", $('#photoDateTaken').val());
				formData.append("photoTitle", $('#photoTitle').val());
				formData.append("upload", $('#realupload')[0].files[0]);
				formData.append("userName", $('#userName').val());
				formData.append("__RequestVerificationToken", reqVerifyToken);
				if (_log) console.log('submitHandler.formData:', formData);//always empty in log
				if (_log) console.log('submitHandler.url:', basePath + '/adduserreport');
				if (_log) console.log('submitHandler.reportType:', reportType);

				$.ajax({
					type: 'POST',
					cache: false,
					url: basePath + '/adduserreport',
					contentType: false,
					processData: false,
					data: formData,
					success: function (data, status) {
						data = JSON.parse(data);
						if (_log) console.log('success.data: ', data);
						if (_log) console.log('success.status: ', status);
						if (data['error'] == 0 || data['error'] == '0') {
							$('#uploadMessages').html('');//Your image is uploaded successfully. Thank you for your submission.
							tw.Analytics.ga4(baseCategory, 'Share Photos - @gaShort', 'Add a Photo', 'onsubmit');
							resetFormUserSubmit();
							openSubpane({subpane: 'share-photos-thanks'});//reroute to subpane
						} else {
							$('.js-form-submit').show();
							$('#uploadMessages').html('<span class="error">Error: ' + data.error + '</span>');
						}
					},
					error: function (xhr, status, err) {
						console.log(xhr, status, error);
						$('.js-form-submit').show();
					},
					complete: function () {
						//console.log('ajax.complete');
					}
				});

            },
            errorPlacement: function (error, element) {
                error.insertBefore(element);
            }
		});
	}
	
	/**
	 * Rest form
	 */
	var resetFormUserSubmit = function () {
		if(_log) console.log('resetFormUserSubmit()');
		$('#sourceLoc').val('');
		$('#comments').val('');
		$('#latitude').val('');
		$('#longitude').val('');
		$('#photoDateTaken').val('');
		$('#photoTitle').val('');
		$('#realupload').val('');
		$('#uploadMessages').html('');
		$('.js-form-submit').show();
	}


	/**
	 * Rest form
	 */

	var resetFormShare = function () {
		if(_log) console.log('resetFormShare()');
		$('.js-share-thankyou-container').addClass('hidden');
		$('.js-share-form-container').removeClass('hidden');
		var $shareSubpane = $subpanes.filter('[data-subpane="share"]');

		$shareSubpane.find('#Url').val(basePath + '/' + reportType);
		//keep your info
		//$shareSubpane.find('#YourName').val('');
		//$shareSubpane.find('#YourEmail').val('');
		$shareSubpane.find('#FriendName').val('');
		$shareSubpane.find('#FriendEmail').val('');
		$shareSubpane.find('#Message').val('');

		grecaptcha.reset();

	}


	// /**
	//  * Submit Share by Email form
	//  * @param {*} button 
	//  */
    // var shareByEmail = function (button) { 
    //     var form = button.parents("form");
    //     if(_log) console.log('form:', $(form).serialize());
    //     $.ajax({
    //         type: "POST",
    //         url: basePath + '/email?' + $(form).serialize(),
    //         success: function (data) {
	// 			if(_log) console.log('shareByEmail.success.data:', data);
	// 			//$(form).html(data);
	// 			$('.js-share-thankyou-container').removeClass('hidden');
	// 			$('.js-share-form-container').addClass('hidden');
	// 			tw.Analytics.ga4(baseCategory, 'Share', 'Email');
    //         },
    //         error: function (xhr, status, err) {
    //             console.log(xhr, status, err);
    //             alert("Sorry! Your submission cannot be processed at this time.")
    //         }
    //     });
    // } 


    var share = function () {
        var facebook = function (url) {
            url = "https://www.travelwisconsin.com" + url;

            windowOpen('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url));
			tw.Analytics.ga4(baseCategory, 'Share', 'Facebook');
        };

        var twitter = function (url, type, name) {
            url = "https://www.travelwisconsin.com" + url;

            var text = "Check out the " + baseCategory + " from @TravelWI";

            windowOpen('https://twitter.com/share?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url));
			tw.Analytics.ga4(baseCategory, 'Share', 'Twitter');
        };

        var email = function (url, type, name, showSocialLinks) {
            var text = "Check out the " + baseCategory + " from @TravelWi";

			tw.Analytics.ga4('Email', 'Share', url);
        };

        var pinterest = function (url, type, name, img) {
            url = "https://www.travelwisconsin.com" + url;
            img = "https://www.travelwisconsin.com" + img;
            var text = "Check out the " + baseCategory + " on TravelWisconsin.com";


            var fullUrl = "//pinterest.com/pin/create/button/?url=" + encodeURIComponent(url) + "&media=" + encodeURIComponent(img) + "&description=" + encodeURIComponent(text);

            windowOpen(fullUrl);
			tw.Analytics.ga4(baseCategory, 'Share', 'Pinterest');
        };

        var windowOpen = function (windowUrl) {
            window.open(windowUrl, 'sharer', 'width=626,height=436');
        };



        return {
            Facebook: facebook,
            Twitter: twitter,
            Email: email,
            Pinterest: pinterest
        };
	}();
	
	var getReportTypeEnum = function () {
		return reportTypeEnum;
	}

	var getReportType = function() {
		return reportType;
	}

	var getReportSubcode = function() {
		return reportSubcode;
	}

	var openDowhillModal = function () {
		//console.log('openDowhillModal()');

		var confirm = '<div id="dialog-confirm" title="Know Before You Go">';
			confirm += '<div>';
			confirm += '<p>Please call or visit the individual resort or destination website in advance of your visit for specific guidelines related to COVID-19 protocols.</p>';
			confirm += '</div>';
			confirm += '</div>';
			
		$('body').append(confirm);

		$("#dialog-confirm").dialog({
			resizable: false,
			height: "auto",
			width: 400,
			modal: true,
			// buttons: {
			// 	"OK": function() {
			// 		$(this).dialog( "close" );
			// 	},
			// 	// Cancel: function() {
			// 	// 	$(this).dialog( "close" );
			// 	// }
			// }
		});
	}

	var openTrailModal = function () {
		//console.log('openTrailModal()');

		var confirm = '<div id="dialog-confirm" title="Know Before You Go">';
			confirm += '<div>';
			//HOLD THIS for Spring when this kicks back in
			// confirm += '<p>Use the Trail Report to understand general conditions across hiking and biking trail networks in Wisconsin. Keep in mind that conditions can change rapidly due to weather, so keep an eye on the forecast and check trail conditions before heading out on your next outdoor adventure.</p>';
			// confirm += '<p>To find trail maps and information on difficulty levels, please visit the partner websites linked in each report or download a separate map app to guide you on the trail.</p>';
			//HOLD THIS FOR WINTER.
			confirm += '<p>Thanks for visiting your go-to resource for Wisconsin’s hiking and biking trails! While the Trail Report is on pause for the winter season, you can still find the latest conditions for your favorite winter activities in the <a href="/snowreport" target="_self" class="btn btn-link d-inline p-0">Wisconsin Snow Report</a>.';
            confirm += '<p>The Trail Report will return in spring with trail conditions to help plan your next outdoor adventure!</p>';
			confirm += '</div>';
			confirm += '</div>';

		$('body').append(confirm);

		$("#dialog-confirm").dialog({
			resizable: false,
			height: "auto",
			width: 400,
			modal: true
		});

		setTimeout(() => {
			//console.log('openTrailModal.timeout');
			$('.ui-dialog-titlebar .ui-button').focus();
		}, 300);
	}

	var openFcrVideoModal = function () {
		//console.log('openFcrVideoModal()');

		var confirm = '<div id="dialog-confirm" title="Here\'s to Being Awed By Autumn">';
			confirm += '<div>';
			confirm += '<p>Here\'s to being awed by autumn in Wisconsin. To exploring breathtaking beauty and enjoying classic fall festivities with family and friends. To adventures on the water and above towering treelines lit up with brilliant color. Here\'s to fall flavors that taste even better when shared and to magical moments designed for all.</p>';
			confirm += '<div><iframe width="100%" height="315" src="https://www.youtube.com/embed/rEis-mQ85Sk?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';
			confirm += '</div>';
			confirm += '</div>';
		$('body').append(confirm);

		$("#dialog-confirm").dialog({
			resizable: false,
			height: "auto",
			width: 600,
			modal: true,
			close: function( event, ui ) {
				$(this).dialog("destroy");
				$("#dialog-confirm").remove();
			}
		});
	}

    $(initializePage); //doc ready

	return {
		clearActive: clearActive,
		closeSubpanes: closeSubpanes,
		getBaseCategory: getBaseCategory,
		getPaneInfo: getPaneInfo,
		getReportTitle: getReportTitle,
		initializeMap: initializeMap,
		openSubpane: openSubpane,
		resetAllPanes: resetAllPanes,
		normalizeText: normalizeText,
		setPaneRecords: setPaneRecords,
        share: share,
        isLargeLayout: isLargeLayout,
		openPane: openPane,
		getReportTypeEnum: getReportTypeEnum,
		getReportType: getReportType,
		getReportSubcode: getReportSubcode
	}
}());